import {
    Modal as ModalContainer,
    Box,
    GridLegacy as Grid
} from '@mui/material';
import { SecondaryButtonStyle, PrimaryButtonStyle } from './IntegrationDialog';
import { DanskeBankConnect } from './systemConnectDialog/DanskeBankConnect';
import { PlandayConnect } from './systemConnectDialog/PlandayConnect';
import { IntectConnect } from './payrollConnect/IntectConnect';
import { ConnectHeader } from './ConnectHeader';
import { useMemo } from 'react';
import { TamigoConnect } from './systemConnectDialog/TamigoConnect';
import { SameSystemConnect } from './systemConnectDialog/SameSystemConnect';
import { ProlonConnect } from './systemConnectDialog/ProloenConnect';
import { ConfirmationBox } from '@/pages/company/componants/Base';
import { TitanPlanConnect } from './systemConnectDialog/TitanPlanConnect';
import { EposConnect } from './payrollConnect/EposConnect';
import { LessorConnect } from './payrollConnect/LessorConnect';
import { StaffConnect } from './systemConnectDialog/StaffConnect';
import { QuinyxConnect } from './systemConnectDialog/QuinyxConnect';
import { DagrofaLonConnect } from './payrollConnect/DagrofaLonConnect';
import { DataLonConnect } from './systemConnectDialog/DataLonConnect';
import { DatevLodasConnect } from './systemConnectDialog/DatevLodasConnect';
import { TrivecConnect } from './systemConnectDialog/TrivecConnect';
import { WorkForceConnect } from './systemConnectDialog/WorkForceConnect';
import { WorkfeedConnect } from './systemConnectDialog/WorkfeedConnect';
import { D365FinanceOperationsConnect } from './payrollConnect/D365FinanceOperationsConnect';
import { ZenegyPortfolioConnect } from './payrollConnect/ZenegyPortfolioConnect';
import { ZENEGY_PORTFOLIO } from '@/utils/constant';

interface IntegrationModalProps {
    dialogOpen: boolean;
    title: string;
    description?: string;
    content?: JSX.Element | string;
    logo?: JSX.Element | null;
    showCancelButton?: boolean;
    showConnectButton?: boolean;
    handleBack?: () => void;
    handleConnect?: () => void;
    placeholder1?: string | any;
    placeholder2?: string | any;
    placeholder3?: string | any;
    id?: string;
    buttonTitle1?: string | null;
    buttonTitle2?: string | null;
    connectServiceName?: string;
    displayFields?: boolean | null; //TODO : move to strategy pattern
    url?: any;
    content2?: JSX.Element | string | null;
    content3?: JSX.Element | string | null;
    width?: string;
    disableButton?: any;
}

export const ConnectService = (props: IntegrationModalProps) => {
    const connectionComponent = useMemo(() => {
        if (props?.connectServiceName === 'DanskeBank') {
            return (
                <DanskeBankConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                    danskeBankButtonTitle={props?.buttonTitle2!}
                />
            );
        }

        if (props?.connectServiceName === 'Planday') {
            return (
                <PlandayConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Intect') {
            return (
                <IntectConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                    IntectButtonTitle={props?.buttonTitle2!}
                />
            );
        }

        if (props?.connectServiceName === 'Tamigo') {
            return (
                <TamigoConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'SameSystem') {
            return (
                <SameSystemConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'ProLoen') {
            return (
                <ProlonConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'TitanPlan') {
            return (
                <TitanPlanConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'DanLon') {
            return null;
        }

        if (props?.connectServiceName === 'DataLon') {
            return (
                <DataLonConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'DatevLodasFile') {
            return (
                <DatevLodasConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Epos') {
            return (
                <EposConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Staff') {
            return (
                <StaffConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Lessor') {
            return (
                <LessorConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                    LessorButtonTitle={props?.buttonTitle2!}
                />
            );
        }

        if (props?.connectServiceName === 'Quinyx') {
            return (
                <QuinyxConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'DagrofaLon') {
            return (
                <DagrofaLonConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Trivec') {
            return (
                <TrivecConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'WorkForce') {
            return (
                <WorkForceConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'Workfeed') {
            return (
                <WorkfeedConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === ZENEGY_PORTFOLIO) {
            return (
                <ZenegyPortfolioConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        if (props?.connectServiceName === 'D365FinanceOperations') {
            return (
                <D365FinanceOperationsConnect
                    onSaveSuccess={props?.handleConnect}
                    onClose={props?.handleBack}
                />
            );
        }

        return (
            <Box width={'100%'} margin={'20px 0 10px'}>
                {' '}
                New provider not setup{' '}
            </Box>
        );
    }, [props?.connectServiceName]);

    const handleConnect = () => {
        if (props?.handleConnect) {
            props.handleConnect();
        }
    };

    return (
        <>
            <ModalContainer open={props.dialogOpen} onClose={props.handleBack}>
                <ConfirmationBox style={{ width: props?.width }}>
                    <ConnectHeader
                        logo={props.logo}
                        title={props.title}
                        id={props.id}
                        content={props.content}
                        description={props.description}
                        content2={props.content2}
                        content3={props.content3}
                    />

                    {props.displayFields && <>{connectionComponent}</>}

                    {!props.displayFields && (
                        <Grid
                            m={'20px 0'}
                            container
                            justifyContent={'space-around'}
                        >
                            {props.showCancelButton !== false && (
                                <SecondaryButtonStyle
                                    onClick={props.handleBack}
                                >
                                    {props.buttonTitle1}
                                </SecondaryButtonStyle>
                            )}
                            {props.showConnectButton !== false && (
                                <a
                                    href={props.url}
                                    style={{
                                        color: 'white',
                                        textDecoration: 'none'
                                    }}
                                    onClick={handleConnect}
                                >
                                    <PrimaryButtonStyle
                                        disabled={props?.disableButton}
                                    >
                                        {props.buttonTitle2}
                                    </PrimaryButtonStyle>
                                </a>
                            )}
                        </Grid>
                    )}
                </ConfirmationBox>
            </ModalContainer>
        </>
    );
};
